module.exports = __webpack_public_path__ + "img/sample-report-02@3x.b44267be.png";